module.exports = __webpack_public_path__ + "assets/img/941587019232_.pic_hd.e4864f0c.jpg";